export const GRAPHQL_ERROR_CODES = {
  CONTRACT_NOT_FOUND: 'CONTRACT_NOT_FOUND',
  AUTHORIZATION_DENIED: 'authorization',
  SUBSCRIPTION_ID_NOT_PROVIDED: 'SUBSCRIPTION_ID_NOT_PROVIDED',
  INVALID_GUID: 'FORMAT'
};

export const ERRORS_404 = [
  GRAPHQL_ERROR_CODES.CONTRACT_NOT_FOUND,
  GRAPHQL_ERROR_CODES.SUBSCRIPTION_ID_NOT_PROVIDED,
  GRAPHQL_ERROR_CODES.INVALID_GUID
];

export const ERRORS_403 = [
  GRAPHQL_ERROR_CODES.AUTHORIZATION_DENIED,
];

export const CUSTOM_ERROR_MESSAGES = {
  AUTHORIZATION_DENIED: 'You are not authorised to perform this action. Please contact your administrator.'
};